"use client"

import { initializeApp, getApps, getApp, type FirebaseApp } from "firebase/app"
import { getAuth, GoogleAuthProvider, type Auth } from "firebase/auth"

import firebaseConfig, { isFirebaseConfigured } from "./firebase-config"

let authInstance: Auth | null = null

function getApp_(): FirebaseApp | null {
  if (typeof window === "undefined") return null
  if (!isFirebaseConfigured()) return null
  return getApps().length ? getApp() : initializeApp(firebaseConfig)
}

export function getFirebaseAuth(): Auth | null {
  if (authInstance) return authInstance
  const app = getApp_()
  if (!app) return null
  authInstance = getAuth(app)
  return authInstance
}

export function getGoogleProvider(): GoogleAuthProvider {
  const provider = new GoogleAuthProvider()
  provider.setCustomParameters({ prompt: "select_account" })
  return provider
}

export { isFirebaseConfigured }
